require('./bootstrap')
require('bootstrap')

// Import bootstrap4-toggle module
require('bootstrap4-toggle');

/* 01. Global Variable
------------------------------------------------ */
window.FONT_FAMILY = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"';
window.COLOR_BLUE = '#1f6bff';
window.COLOR_GREEN = '#1abd36';
window.COLOR_ORANGE = '#ff9500';
window.COLOR_RED = '#ff3b30';
window.COLOR_AQUA = '#30beff';
window.COLOR_PURPLE = '#5b2e91';
window.COLOR_YELLOW = '#ffcc00';
window.COLOR_INDIGO = '#640df3';
window.COLOR_PINK = '#ff2d55';
window.COLOR_TEAL = '#0cd096';
window.COLOR_BLACK = '#000000';
window.COLOR_WHITE = '#FFFFFF';
window.COLOR_GRAY_100 = '#ebeef4';
window.COLOR_GRAY_200 = '#dae0ec';
window.COLOR_GRAY_300 = '#c9d2e3';
window.COLOR_GRAY_400 = '#a8b6d1';
window.COLOR_GRAY_500 = '#869ac0';
window.COLOR_GRAY_600 = '#657eae';
window.COLOR_GRAY_700 = '#4d6593';
window.COLOR_GRAY_800 = '#3c4e71';
window.COLOR_GRAY_900 = '#212837';


/* 04. Handle Sidebar Menu
------------------------------------------------ */
var handleSidebarMenu = function () {
    "use strict";
    $(document).on('click', '.app-sidebar .menu > .menu-item.has-sub > .menu-link', function (e) {
        e.preventDefault();

        var target = $(this).next('.menu-submenu');
        var otherMenu = $('.app-sidebar .menu > .menu-item.has-sub > .menu-submenu').not(target);

        if ($('.app-sidebar-minified').length === 0) {
            $(otherMenu).slideUp(250);
            $(otherMenu).closest('.menu-item').removeClass('expand');

            $(target).slideToggle(250);
            var targetElm = $(target).closest('.menu-item');
            if ($(targetElm).hasClass('expand')) {
                $(targetElm).removeClass('expand');
            } else {
                $(targetElm).addClass('expand');
            }
        }
    });
    $(document).on('click', '.app-sidebar .menu > .menu-item.has-sub .menu-submenu .menu-item.has-sub > .menu-link', function (e) {
        e.preventDefault();

        if ($('.app-sidebar-minified').length === 0) {
            var target = $(this).next('.menu-submenu');
            $(target).slideToggle(250);
        }
    });
};


/* 05. Handle Sidebar Minify
------------------------------------------------ */
var MOBILE_SIDEBAR_TOGGLE_CLASS = 'app-sidebar-mobile-toggled';
var MOBILE_SIDEBAR_CLOSED_CLASS = 'app-sidebar-mobile-closed';
var handleSidebarMinify = function () {
    $('[data-toggle="sidebar-minify"]').on('click', function (e) {
        e.preventDefault();

        var targetElm = '#app';
        var targetClass = 'app-sidebar-minified';

        if ($(targetElm).hasClass(targetClass)) {
            $(targetElm).removeClass(targetClass);
            localStorage.removeItem('appSidebarMinified');
        } else {
            $(targetElm).addClass(targetClass);
            localStorage.setItem('appSidebarMinified', true);
        }
    });

    if (typeof (Storage) !== 'undefined') {
        if (localStorage.appSidebarMinified) {
            $('#app').addClass('app-sidebar-minified');
        }
    }
};
var handleSidebarMobileToggle = function () {
    $(document).on('click', '[data-toggle="sidebar-mobile"]', function (e) {
        e.preventDefault();

        var targetElm = '#app';

        $(targetElm).removeClass(MOBILE_SIDEBAR_CLOSED_CLASS).addClass(MOBILE_SIDEBAR_TOGGLE_CLASS);
    });
};
var handleSidebarMobileDismiss = function () {
    $(document).on('click', '[data-dismiss="sidebar-mobile"]', function (e) {
        e.preventDefault();

        var targetElm = '#app';

        $(targetElm).removeClass(MOBILE_SIDEBAR_TOGGLE_CLASS).addClass(MOBILE_SIDEBAR_CLOSED_CLASS);
        setTimeout(function () {
            $(targetElm).removeClass(MOBILE_SIDEBAR_CLOSED_CLASS);
        }, 250);
    });
};


/* 06. Handle Sidebar Minify Float Menu
------------------------------------------------ */
var floatSubMenuTimeout;
var targetFloatMenu;
var handleMouseoverFloatSubMenu = function (elm) {
    clearTimeout(floatSubMenuTimeout);
};
var handleMouseoutFloatSubMenu = function (elm) {
    floatSubMenuTimeout = setTimeout(function () {
        $('.app-float-submenu').remove();
    }, 250);
};
var handleSidebarMinifyFloatMenu = function () {
    $(document).on('click', '.app-float-submenu .menu-item.has-sub > .menu-link', function (e) {
        e.preventDefault();

        var target = $(this).next('.menu-submenu');
        $(target).slideToggle(250, function () {
            var targetMenu = $('.app-float-submenu');
            var targetHeight = $(targetMenu).height() + 20;
            var targetOffset = $(targetMenu).offset();
            var targetTop = $(targetMenu).attr('data-offset-top');
            var windowHeight = $(window).height();
            if ((windowHeight - targetTop) > targetHeight) {
                $('.app-float-submenu').css({
                    'top': targetTop,
                    'bottom': 'auto',
                    'overflow': 'initial'
                });
            } else {
                $('.app-float-submenu').css({
                    'bottom': 0,
                    'overflow': 'scroll'
                });
            }
        });
    });
    $(document).on('mouseover', '.app-sidebar-minified .app-sidebar .menu .menu-item.has-sub > .menu-link', function () {
        clearTimeout(floatSubMenuTimeout);

        var targetMenu = $(this).closest('.menu-item').find('.menu-submenu').first();
        if (targetFloatMenu == this) {
            return false;
        } else {
            targetFloatMenu = this;
        }
        var targetMenuHtml = $(targetMenu).html();

        if (targetMenuHtml) {
            var targetHeight = $(targetMenu).height() + 20;
            var targetOffset = $(this).offset();
            var targetTop = targetOffset.top - $(window).scrollTop();
            var targetLeft = ($('body').css('direction') != 'rtl') ? $('#sidebar').width() + $('#sidebar').offset().left : 'auto';
            var targetRight = ($('body').css('direction') != 'rtl') ? 'auto' : $('#sidebar').width();
            var windowHeight = $(window).height();
            var submenuHeight = 0;
            console.log(targetLeft);
            if ($('.app-float-submenu').length == 0) {
                targetMenuHtml = '<div class="app-float-submenu" data-offset-top="' + targetTop + '" onmouseover="handleMouseoverFloatSubMenu(this)" onmouseout="handleMouseoutFloatSubMenu(this)">' + targetMenuHtml + '</div>';
                $('body').append(targetMenuHtml);
            } else {
                $('.app-float-submenu').html(targetMenuHtml);
            }
            submenuHeight = $('.app-float-submenu').height();
            if ((windowHeight - targetTop) > targetHeight && ((targetTop + submenuHeight) < windowHeight)) {
                $('.app-float-submenu').css({
                    'top': targetTop,
                    'left': targetLeft,
                    'bottom': 'auto',
                    'right': targetRight
                });
            } else {
                $('.app-float-submenu').css({
                    'bottom': 0,
                    'top': 'auto',
                    'left': targetLeft,
                    'right': targetRight
                });
            }
        } else {
            $('.app-float-submenu').remove();
            targetFloatMenu = '';
        }
    });
    $(document).on('mouseout', '.app-sidebar-minified .app-sidebar .menu > .menu-item.has-sub > .menu-link', function () {
        floatSubMenuTimeout = setTimeout(function () {
            $('.app-float-submenu').remove();
            targetFloatMenu = '';
        }, 250);
    });
}


/* 07. Handle Dropdown Close Option
------------------------------------------------ */
var handleDropdownClose = function () {
    $(document).on('click', '[data-dropdown-close="false"]', function (e) {
        e.stopPropagation();
    });
};


/* 08. Handle Card - Remove / Reload / Collapse / Expand
------------------------------------------------ */
var cardActionRunning = false;
var handleCardAction = function () {
    "use strict";

    if (cardActionRunning) {
        return false;
    }
    cardActionRunning = true;

    // expand
    $(document).on('mouseover', '[data-toggle=card-expand]', function (e) {
        if (!$(this).attr('data-init')) {
            $(this).tooltip({
                title: 'Expand / Compress',
                placement: 'bottom',
                trigger: 'hover',
                container: 'body'
            });
            $(this).tooltip('show');
            $(this).attr('data-init', true);
        }
    });
    $(document).on('click', '[data-toggle=card-expand]', function (e) {
        e.preventDefault();
        var target = $(this).closest('.card');
        var targetBody = $(target).find('.card-body');
        var targetClass = 'card-expand';
        var targetTop = 40;
        if ($(targetBody).length !== 0) {
            var targetOffsetTop = $(target).offset().top;
            var targetBodyOffsetTop = $(targetBody).offset().top;
            targetTop = targetBodyOffsetTop - targetOffsetTop;
        }

        if ($('body').hasClass(targetClass) && $(target).hasClass(targetClass)) {
            $('body, .card').removeClass(targetClass);
            $('.card').removeAttr('style');
            $(targetBody).removeAttr('style');
        } else {
            $('body').addClass(targetClass);
            $(this).closest('.card').addClass(targetClass);
        }
        $(window).trigger('resize');
    });
};


/* 09. Handle Tooltip & Popover Activation
------------------------------------------------ */
var handelTooltipPopoverActivation = function () {
    "use strict";
    if ($('[data-toggle="tooltip"]').length !== 0) {
        $('[data-toggle=tooltip]').tooltip();
    }
    if ($('[data-toggle="popover"]').length !== 0) {
        $('[data-toggle=popover]').popover();
    }
};


/* 10. Handle Scroll to Top Button Activation
------------------------------------------------ */
var handleScrollToTopButton = function () {
    "use strict";
    $(document).on('scroll', function () {
        var totalScroll = $(document).scrollTop();

        if (totalScroll >= 200) {
            $('[data-click=scroll-top]').addClass('show');
        } else {
            $('[data-click=scroll-top]').removeClass('show');
        }
    });
    $('[data-click=scroll-top]').on('click', function (e) {
        e.preventDefault();
        $('html, body, .content').animate({
            scrollTop: $("body").offset().top
        }, 500);
    });
};

/* 12. Handle Scroll to
------------------------------------------------ */
var handleScrollTo = function () {
    $(document).on('click', '[data-toggle="scroll-to"]', function (e) {
        e.preventDefault();

        var targetElm = ($(this).attr('data-target')) ? $(this).attr('data-target') : $(this).attr('href');
        if (targetElm) {
            $('html, body').animate({
                scrollTop: $(targetElm).offset().top - $('#header').height() - 24
            }, 0);
        }
    });
};


/* Application Controller
------------------------------------------------ */
var App = function () {
    "use strict";

    return {
        //main function
        init: function () {
            this.initSidebar();
            this.initHeader();
            this.initComponent();
        },
        initSidebar: function () {
            handleSidebarMinifyFloatMenu();
            handleSidebarMenu();
            handleSidebarMinify();
            handleSidebarMobileToggle();
            handleSidebarMobileDismiss();
        },
        initHeader: function () {
        },
        initComponent: function () {
            handleCardAction();
            handelTooltipPopoverActivation();
            handleScrollToTopButton();
            handleDropdownClose();
            handleScrollTo();
        },
        scrollTop: function () {
            $('html, body, .content').animate({
                scrollTop: $('body').offset().top
            }, 0);
        }
    };
}();

$(document).ready(function () {
    App.init();
});
require('./components/data-refresh')
require('./components/data-chart-load')
require('./components/data-autosubmit')
require('./components/data-input-vis-toggle')
require('./components/data-input-copy')
require('./components/data-input-autoselect')
require('./components/data-load-modal')
require('./components/data-vnc-console')
require('./components/dark-mode')

// cloud server order/selection stuff
// function updateRows() {
//     $(".selection-row").each(function () {
//         let self = $(this);
//         if (self.find('input[type=radio]:checked,input[type=checkbox]:checked').length > 0) {
//             self.addClass("selected");
//         } else {
//             self.removeClass("selected");
//         }
//     });
// }
// updateRows();
// $("body").on("click",".selection-row", function () {
//     $(this).find('input[type=radio]').prop("checked", true);
//     $(this).find('input[type=checkbox]').each(function (){
//         $(this).prop('checked',!$(this).prop('checked'));
//     });
//     updateRows();
//     var ptypeElement = $(this).find('#ptype');
//     if (ptypeElement.length > 0) {
//         var ptypeValue = ptypeElement.val();
//         console.log('ptype =', ptypeValue);
//     }
// });


//// XXXX

// function updateRows() {
//     $(".selection-row").each(function () {
//         let self = $(this);
//         if (self.find('input[type=radio]:checked,input[type=checkbox]:checked').length > 0) {
//             self.addClass("selected");
//         } else {
//             self.removeClass("selected");
//         }
//     });
// }
//
// updateRows();
//
// function updateTotalPrice() {
//         // Prüfen, ob ein Preis vorhanden ist
//         var priceElement = $(".selection-row input[type=radio]:checked").closest(".selection-row").find("#price_m");
//         console.log("priceElement: " + priceElement);
//         //var priceElement = $(".selection-row input[type=radio]:checked").closest(".selection-row").find("#price_autobackup_m");
//         var priceSnapshot = $(".selection-row input[type=radio]:checked").closest(".selection-row").find("#price_snapshot");
//          console.log("priceSnapshot: " + priceElement);
//         if (priceElement.length > 0) {
//             // Preis auslesen und aktualisieren
//             var price = parseFloat(priceElement.text()) / 100;
//             var autobackupPrice = $("input[name='autobackups']:checked").val() == 1 ? parseFloat($(".backupPrice").text()) : 0; // Autobackup-Preis
//             var snapshotsCount = parseFloat($("#snapshotSlider").val()); // Anzahl der Snapshots
//             var total = price + (snapshotsCount * (priceSnapshot/100)) + autobackupPrice; // Gesamtpreis
//             var total_h = total / 600; // Gesamtpreis
//
//             $("#currentPrice").text(total.toFixed(2) + " €"); // Hier den aktualisierten Preis anzeigen
//             $("#currentPrice_h").text(total_h.toFixed(4) + " €"); // Hier den aktualisierten Preis anzeigen
//         }
//     }
//
// $("body").on("click", ".selection-row", function () {
//     $(this).find('input[type=radio]').prop("checked", true);
//     $(this).find('input[type=checkbox]').each(function () {
//         $(this).prop('checked', !$(this).prop('checked'));
//     });
//     updateRows();
//     var ptypeElement = $(this).find('#ptype');
//     if (ptypeElement.length > 0) {
//
//         //var ptypeValue = ptypeElement.val();
//         //console.log('ptype =', ptypeValue);
//         var priceAutobackupM = $(this).find("#price_autobackup_m").text();
//         //console.log('price_autobackup_m =', priceAutobackupM);
//
//         var price = $(this).find("#price_m").text();
//         //console.log('price =', price);
//         $(".backupPrice").text(priceAutobackupM / 100);
//     }
//
//     if ($(this).find('input[name="autobackups"][value="0"]').is(":checked")) {
//         $('#noBackupsModal').modal('show');
//     }
//     updateTotalPrice();
//
// });
// // Event-Listener für Änderungen an der Anzahl der Snapshots
// $('#snapshotSlider').on('input', function () {
//     var snapshotsCount = $(this).val(); // Anzahl der Snapshots
//     $("#snapshotCount").text(snapshotsCount); // Anzahl der Snapshots anzeigen
//     // Gesamtpreis aktualisieren
//     updateTotalPrice();
// });
//
// // Event-Listener für Änderungen an der Auswahl des Backups
// $("body").on("change", "input[name='autobackups']", function () {
//     // Gesamtpreis aktualisieren
//     updateTotalPrice();
// });
